import React, { Fragment, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { clearErrorAction, OrderDetailAction } from '../../redux/actions/orderAction';
import Loader from '../../layout/loader';
import swal from 'sweetalert';
import MetaTag from '../../layout/MetaTag';
import Navbar from '../HomeScreen/Navbar';
import Footer from '../HomeScreen/bottomsection/Footer';
import GetAppIcon from '@material-ui/icons/GetApp';
import PrintIcon from '@material-ui/icons/Print';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import StorefrontIcon from '@material-ui/icons/Storefront';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import PersonIcon from '@material-ui/icons/Person';
import PaymentIcon from '@material-ui/icons/Payment';
import ReceiptIcon from '@material-ui/icons/Receipt';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import CloseIcon from '@material-ui/icons/Close';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import './delivery.css';

function DeliveryProductDetail(props) {
  const dispatch = useDispatch();
  const { error, loading, order } = useSelector((state) => state.orderDetail);

  const [copied, setCopied] = useState(false);
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);

  useEffect(() => {
    if (error) {
      swal({
        title: "Error",
        text: error,
        icon: 'error',
      });
      dispatch(clearErrorAction());
    }

    dispatch(OrderDetailAction(props.match.params.id));
  }, [dispatch, error, props.match.params.id]);

  const copyOrderId = () => {
    if (order && order._id) {
      navigator.clipboard?.writeText(order._id);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  // Find seller store details from order or its items
  const sellerStore =
    (order && order.store && typeof order.store === 'object' && order.store.name ? order.store : null) ||
    (order && order.orderItems && order.orderItems[0]?.store && typeof order.orderItems[0].store === 'object' ? order.orderItems[0].store : null) ||
    (order && order.orderItems && order.orderItems[0]?.product?.store && typeof order.orderItems[0].product.store === 'object' ? order.orderItems[0].product.store : null);

  const sellerName = sellerStore?.name || order?.fulfillment?.pickupStoreName || "IM Online Partner Merchant";
  const sellerCity = sellerStore?.address?.city || "Ahmedgarh";
  const sellerState = sellerStore?.address?.state || "Punjab";
  const sellerPincode = sellerStore?.address?.pincode || "148021";
  const sellerStreet = sellerStore?.address?.street || "";
  const sellerFullAddress = [sellerStreet, sellerCity, sellerState, sellerPincode].filter(Boolean).join(", ") || "Ahmedgarh, Punjab - 148021";
  const sellerContactPhone = sellerStore?.contact?.phone || "+91 9653331029";
  const sellerContactEmail = sellerStore?.contact?.email || "information@imonline.shop";
  const sellerSlug = sellerStore?.slug || "";

  // Compute status stepper index (0: Placed, 1: Confirmed, 2: Shipped, 3: Out for Delivery, 4: Delivered)
  const getStepIndex = (status) => {
    const s = String(status || '').toLowerCase();
    if (s === 'delivered') return 4;
    if (s === 'out for delivery') return 3;
    if (s === 'shipped') return 2;
    if (s === 'confirmed') return 1;
    return 1; // Default Processing is Confirmed/Processing
  };

  const isCancelled = order?.orderStatus === 'Cancel' || order?.orderStatus === 'Cancelled';
  const isReturned = order?.orderStatus === 'Returned';
  const currentStep = getStepIndex(order?.orderStatus);

  const orderDateFormatted = order?.paidAt || order?.createdAt ? new Date(order.paidAt || order.createdAt).toLocaleDateString('en-IN', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  }) : 'Recently';

  const invoiceNumber = `INV-IM-${String(order?._id || '').slice(-8).toUpperCase()}`;

  const isCOD = order?.paymentMode === 'COD' || order?.paymentInfo?.id === 'COD';
  const isAdvanceCOD = order?.paymentMode === 'ADVANCE_COD';
  const isOnlinePaid = !isCOD && !isAdvanceCOD;

  const dueAmount = isCOD
    ? (order?.remainingAmount || order?.totalPrice || 0)
    : isAdvanceCOD
      ? (order?.remainingAmount || Math.max((order?.totalPrice || 0) - (order?.adavncePayment?.amount || 0), 0))
      : 0;

  return (
    <Fragment>
      <MetaTag title={`Order #${order?._id || ''} Details & Receipt - IM Online Shopping`} />
      <Navbar />

      {loading || !order ? (
        <Loader />
      ) : (
        <div className="order-details-screen">
          <div className="order-details-screen-interactive">
            
            {/* Top Navigation & Breadcrumb */}
            <div className="order-page-topbar">
              <Link to="/orders/me" className="back-link">
                <ArrowBackIcon style={{ fontSize: '18px', marginRight: '6px' }} />
                Back to My Orders
              </Link>
              <div className="topbar-right-actions">
                <button id="preview-invoice-top-btn" className="preview-receipt-btn" onClick={() => setShowInvoiceModal(true)}>
                  <ReceiptIcon style={{ fontSize: '18px', marginRight: '6px' }} />
                  Preview Invoice
                </button>
                <button className="download-receipt-main-btn" onClick={() => window.print()}>
                  <GetAppIcon style={{ fontSize: '18px', marginRight: '6px' }} />
                  Download / Print Receipt
                </button>
              </div>
            </div>

            {/* Hero Header Card */}
            <div className="order-hero-card">
              <div className="order-hero-top">
                <div className="order-id-group">
                  <span className="order-tag-label">ORDER DETAILS</span>
                  <div className="order-id-display">
                    <h3>#{order._id}</h3>
                    <button className="copy-id-btn" onClick={copyOrderId} title="Copy Order ID">
                      <FileCopyIcon style={{ fontSize: '14px', marginRight: '4px' }} />
                      {copied ? 'Copied!' : 'Copy ID'}
                    </button>
                  </div>
                  <div className="order-meta-dates">
                    <span>Placed on {orderDateFormatted}</span>
                    <span className="bullet-divider">•</span>
                    <span>Invoice: {invoiceNumber}</span>
                  </div>
                </div>

                <div className="order-status-pill-area">
                  <span className={`status-badge-lg ${isCancelled ? 'cancelled' : isReturned ? 'returned' : String(order.orderStatus).toLowerCase()}`}>
                    {order.orderStatus}
                  </span>
                </div>
              </div>

              {/* Order Tracking Stepper */}
              {!isCancelled && !isReturned && (
                <div className="order-stepper-wrap">
                  <div className="order-stepper">
                    {[
                      { label: 'Order Placed', desc: 'Received by system' },
                      { label: 'Order Confirmed', desc: 'Merchant accepted' },
                      { label: 'Shipped', desc: 'Dispatched to courier' },
                      { label: 'Out for Delivery', desc: 'With local driver' },
                      { label: 'Delivered', desc: 'Delivered to you' },
                    ].map((step, idx) => {
                      const isComplete = idx <= currentStep;
                      const isCurrent = idx === currentStep;
                      return (
                        <div className={`stepper-step ${isComplete ? 'completed' : ''} ${isCurrent ? 'current' : ''}`} key={idx}>
                          <div className="step-marker">
                            {isComplete ? <CheckCircleIcon style={{ fontSize: '18px' }} /> : <span>{idx + 1}</span>}
                          </div>
                          <div className="step-content">
                            <span className="step-title">{step.label}</span>
                            <span className="step-desc">{step.desc}</span>
                          </div>
                          {idx < 4 && <div className={`step-connector ${idx < currentStep ? 'active' : ''}`} />}
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}

              {isCancelled && (
                <div className="order-alert-banner cancelled">
                  ⚠️ This order was cancelled. If you made an online payment, your refund will be processed within 5-7 business days.
                </div>
              )}
              {isReturned && (
                <div className="order-alert-banner returned">
                  ↩️ This order has been returned. Your return request is being reviewed by the merchant team.
                </div>
              )}
            </div>

            {/* Main Content 2-Column Grid */}
            <div className="order-details-grid">
              
              {/* Left Column: Seller info, Items, Delivery info */}
              <div className="order-grid-left">
                
                {/* 1. SELLER / MERCHANT CARD */}
                <div className="details-card seller-highlight-card">
                  <div className="card-header-with-badge">
                    <div className="card-header-left">
                      <StorefrontIcon style={{ color: '#0284c7', fontSize: '22px' }} />
                      <div>
                        <h4>Sold & Supplied by Merchant</h4>
                        <span className="subtext">Direct seller attribution & store information</span>
                      </div>
                    </div>
                    {sellerStore?.isVerified !== false && (
                      <span className="verified-seller-badge">
                        <VerifiedUserIcon style={{ fontSize: '15px', marginRight: '4px' }} />
                        Verified Merchant
                      </span>
                    )}
                  </div>

                  <div className="seller-details-body">
                    <div className="seller-main-info">
                      <div className="seller-name-row">
                        <span className="seller-store-name">{sellerName}</span>
                        {sellerSlug && (
                          <Link to={`/store/${sellerSlug}`} className="visit-store-link">
                            Visit Storefront →
                          </Link>
                        )}
                      </div>
                      <p className="seller-address-text">
                        📍 <strong>Store Address:</strong> {sellerFullAddress}
                      </p>
                      <div className="seller-contact-chips">
                        <span className="contact-chip">📞 {sellerContactPhone}</span>
                        <span className="contact-chip">✉️ {sellerContactEmail}</span>
                      </div>
                    </div>

                    <div className="seller-greeting-box">
                      <div className="greeting-flower">🌸</div>
                      <div className="greeting-text">
                        <strong>Best Wishes from {sellerName}:</strong>
                        <p>
                          "Thank you for your order! We take immense pride in carefully packaging and fulfilling your purchase. Warmest best wishes from our local store team and the IM Online Shopping family!"
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* 2. ORDERED ITEMS CARD */}
                <div className="details-card">
                  <div className="card-header-simple">
                    <h4>Items in this Order ({order.orderItems?.length || 0})</h4>
                  </div>
                  <div className="order-items-list">
                    {order.orderItems && order.orderItems.map((item, index) => (
                      <div className="order-item-card" key={index}>
                        <img src={item.image} alt={item.name} className="order-item-image" />
                        <div className="order-item-info">
                          <Link to={`/ProductDetail/${item.product}`} className="order-item-title">
                            {item.name}
                          </Link>
                          <div className="order-item-specs">
                            {item.size && <span className="spec-tag">Size: {item.size}</span>}
                            {item.colour && <span className="spec-tag">Colour: {item.colour}</span>}
                            <span className="spec-tag">Qty: {item.quantity}</span>
                          </div>
                          <div className="item-seller-tag">
                            Sold by: <strong>{sellerName}</strong>
                          </div>
                        </div>
                        <div className="order-item-price-col">
                          <span className="item-price-unit">₹{(item.price || 0).toLocaleString('en-IN')} each</span>
                          <span className="item-price-total">₹{((item.price || 0) * (item.quantity || 1)).toLocaleString('en-IN')}</span>
                          <Link to={`/ProductDetail/${item.product}`} className="item-action-link">
                            View Product
                          </Link>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* 3. SHIPPING / DELIVERY DESTINATION */}
                <div className="details-card">
                  <div className="card-header-left">
                    <LocalShippingIcon style={{ color: '#0f172a', fontSize: '22px' }} />
                    <div>
                      <h4>
                        {order.orderType === 'STORE_PICKUP' || order.orderType === 'CUSTOMER_PICKUP' || order.orderType === 'VENDOR_PICKUP'
                          ? 'Store Pickup Location'
                          : 'Delivery Address'}
                      </h4>
                      <span className="subtext">Recipient contact and location</span>
                    </div>
                  </div>

                  <div className="delivery-info-body">
                    <div className="recipient-row">
                      <div className="recipient-name">
                        <PersonIcon style={{ fontSize: '18px', color: '#64748b', marginRight: '6px' }} />
                        <strong>{order.shippingInfo?.name || 'Customer'}</strong>
                      </div>
                      <span className="recipient-phone">📞 +91 {order.shippingInfo?.phoneNo}</span>
                      {order.shippingInfo?.email && <span className="recipient-email">✉️ {order.shippingInfo.email}</span>}
                    </div>

                    <div className="address-box">
                      {order.orderType && order.orderType !== 'HOME_DELIVERY' ? (
                        <>
                          <div className="pickup-notice">
                            <strong>🏬 Pick up from Store:</strong> {order.fulfillment?.pickupStoreName || sellerName}
                          </div>
                          <p style={{ margin: '4px 0', color: '#475569' }}>
                            {order.fulfillment?.pickupAddress?.street ? `${order.fulfillment.pickupAddress.street}, ${order.fulfillment.pickupAddress.city}` : (order.shippingInfo?.address)}
                          </p>
                          {order.fulfillment?.verificationCode && (
                            <div className="pickup-code-badge">
                              Secret Pickup Code: <strong>{order.fulfillment.verificationCode}</strong>
                            </div>
                          )}
                        </>
                      ) : (
                        <p className="full-address-line">
                          {order.shippingInfo?.address}, {order.shippingInfo?.city}, {(order.shippingInfo?.district ? `${order.shippingInfo.district}, ` : '')}{order.shippingInfo?.state} - <strong>{order.shippingInfo?.pincode}</strong>
                        </p>
                      )}
                    </div>

                    {order.order_id && (
                      <div className="shipping-tracking-bar">
                        <span>Courier Shipping ID: <strong>{order.order_id}</strong></span>
                        {order.shipment_id && <span> | Shipment ID: <strong>{order.shipment_id}</strong></span>}
                      </div>
                    )}
                  </div>
                </div>

              </div>

              {/* Right Column: Payment summary, pricing breakdown, actions */}
              <div className="order-grid-right">
                
                {/* 1. PAYMENT METHOD & STATUS CARD */}
                <div className="details-card payment-status-card">
                  <div className="card-header-left">
                    <PaymentIcon style={{ color: '#0f172a', fontSize: '20px' }} />
                    <h4>Payment Information</h4>
                  </div>

                  <div className="payment-body">
                    <div className="payment-method-row">
                      <span className="payment-mode-pill">
                        {isCOD ? 'Cash on Delivery (COD)' : isAdvanceCOD ? 'Advance Paid (Balance COD)' : 'Online Payment (Cashfree)'}
                      </span>
                      <span className={`payment-status-pill ${isOnlinePaid ? 'paid' : 'due'}`}>
                        {isOnlinePaid ? 'Paid Online' : isCOD ? 'Pay on Delivery' : 'Partially Paid'}
                      </span>
                    </div>

                    {dueAmount > 0 && (
                      <div className="balance-due-alert">
                        <div className="due-label">CASH TO PAY AT DOORSTEP:</div>
                        <div className="due-amount">₹{dueAmount.toLocaleString('en-IN')}</div>
                        <div className="due-note">Please keep exact cash ready upon delivery.</div>
                      </div>
                    )}

                    {isOnlinePaid && (
                      <div className="paid-verified-box">
                        <CheckCircleIcon style={{ color: '#16a34a', fontSize: '20px', marginRight: '6px' }} />
                        <span>Payment verified & received in full via Cashfree.</span>
                      </div>
                    )}
                  </div>
                </div>

                {/* 2. PRICE BREAKDOWN CARD */}
                <div className="details-card pricing-summary-card">
                  <div className="card-header-simple">
                    <h4>Price Breakdown</h4>
                  </div>

                  <div className="breakdown-rows">
                    <div className="breakdown-row">
                      <span>Items Subtotal</span>
                      <span>₹{(order.itemPrice || 0).toLocaleString('en-IN')}</span>
                    </div>
                    <div className="breakdown-row">
                      <span>Delivery / Shipping Fee</span>
                      <span>{(order.shippingPrice || 0) > 0 ? `₹${(order.shippingPrice).toLocaleString('en-IN')}` : <span className="free-tag">FREE</span>}</span>
                    </div>
                    {(order.taxPrice || 0) > 0 && (
                      <div className="breakdown-row">
                        <span>GST Tax</span>
                        <span>₹{(order.taxPrice).toLocaleString('en-IN')}</span>
                      </div>
                    )}
                    {order.coupanInfo && order.coupanInfo.coupanValue > 0 && (
                      <div className="breakdown-row coupon">
                        <span>Coupon Discount ({order.coupanInfo.coupanName})</span>
                        <span className="discount-amount">-₹{(order.coupanInfo.coupanValue).toLocaleString('en-IN')}</span>
                      </div>
                    )}
                    {order.adavncePayment && order.adavncePayment.amount > 0 && (
                      <div className="breakdown-row advance-paid">
                        <span>Advance Paid Online</span>
                        <span className="advance-amount">-₹{(order.adavncePayment.amount).toLocaleString('en-IN')}</span>
                      </div>
                    )}
                    <div className="breakdown-row total-row">
                      <span>Total Order Amount</span>
                      <span className="grand-total-amount">₹{(order.totalPrice || 0).toLocaleString('en-IN')}</span>
                    </div>
                  </div>
                </div>

                {/* 3. QUICK ACTIONS & DOWNLOAD BUTTONS */}
                <div className="details-card actions-card">
                  <button className="receipt-primary-cta" onClick={() => window.print()}>
                    <GetAppIcon style={{ fontSize: '20px', marginRight: '8px' }} />
                    Download / Print Receipt
                  </button>

                  <button id="preview-invoice-cta-btn" className="receipt-secondary-cta" onClick={() => setShowInvoiceModal(true)}>
                    <ReceiptIcon style={{ fontSize: '18px', marginRight: '8px' }} />
                    View Printable Tax Invoice
                  </button>

                  {order.orderStatus === 'Processing' && (
                    <Link to={`/profile/order-cancel/${order._id}`} className="cancel-order-cta">
                      Cancel This Order
                    </Link>
                  )}

                  <div className="help-box">
                    <HelpOutlineIcon style={{ fontSize: '16px', color: '#64748b', marginRight: '6px' }} />
                    <span>Need help? Call +91 7658007326 or email information@imonline.shop</span>
                  </div>
                </div>

              </div>

            </div>

          </div>

          {/* ========================================================================= */}
          {/* OFFICIAL DEDICATED TAX INVOICE & RECEIPT (PRINT & PDF LAYOUT)              */}
          {/* ========================================================================= */}
          <div className="official-print-receipt">
            <div className="invoice-container">
              
              {/* Invoice Header */}
              <div className="inv-header">
                <div className="inv-brand-info">
                  <h1 className="inv-company-name">IM ONLINE SHOPPING CO.</h1>
                  <p className="inv-company-sub">Premier Multi-Vendor E-Commerce Marketplace</p>
                  <p className="inv-company-address">Ahmedgarh, Punjab - 148021 | CIN: U52399PB2026PTC099823</p>
                  <p className="inv-company-contact">Web: www.imonline.shop | Email: information@imonline.shop | Support: +91 7658007326</p>
                </div>
                <div className="inv-title-box">
                  <div className="inv-title-badge">TAX INVOICE / CASH MEMO</div>
                  <div className="inv-meta-line"><strong>Invoice No:</strong> {invoiceNumber}</div>
                  <div className="inv-meta-line"><strong>Order ID:</strong> #{order._id}</div>
                  <div className="inv-meta-line"><strong>Date:</strong> {orderDateFormatted}</div>
                </div>
              </div>

              {/* Two Parties: Sold By (Seller) & Billed To (Customer) */}
              <div className="inv-parties-grid">
                <div className="inv-party-card seller">
                  <div className="party-title">🏪 SOLD & SUPPLIED BY (MERCHANT):</div>
                  <div className="party-name">{sellerName}</div>
                  <div className="party-line">📍 {sellerFullAddress}</div>
                  <div className="party-line">📞 Phone: {sellerContactPhone}</div>
                  <div className="party-line">✉️ Email: {sellerContactEmail}</div>
                  <div className="party-tag">Status: Verified Merchant Partner</div>
                </div>

                <div className="inv-party-card customer">
                  <div className="party-title">📦 BILLED & SHIPPED TO (CUSTOMER):</div>
                  <div className="party-name">{order.shippingInfo?.name || 'Customer'}</div>
                  <div className="party-line">📍 {order.shippingInfo?.address}</div>
                  <div className="party-line">
                    {order.shippingInfo?.city}, {(order.shippingInfo?.district ? `${order.shippingInfo.district}, ` : '')}{order.shippingInfo?.state} - {order.shippingInfo?.pincode}
                  </div>
                  <div className="party-line">📞 Phone: +91 {order.shippingInfo?.phoneNo}</div>
                  {order.shippingInfo?.email && <div className="party-line">✉️ Email: {order.shippingInfo.email}</div>}
                </div>
              </div>

              {/* Payment & Order Mode Bar */}
              <div className="inv-payment-bar">
                <div><strong>Payment Mode:</strong> {isCOD ? 'Cash on Delivery (COD)' : isAdvanceCOD ? 'Advance Paid (Balance on Delivery)' : 'Full Online Payment (Cashfree)'}</div>
                <div><strong>Payment Status:</strong> {isOnlinePaid ? 'PAID IN FULL' : `DUE ON DELIVERY: ₹${dueAmount.toLocaleString('en-IN')}`}</div>
                <div><strong>Fulfillment:</strong> {order.orderType || 'HOME_DELIVERY'}</div>
              </div>

              {/* Itemized Table */}
              <div className="inv-table-responsive">
                <table className="inv-table">
                  <thead>
                    <tr>
                      <th style={{ width: '40px', textAlign: 'center' }}>#</th>
                      <th style={{ textAlign: 'left' }}>Item Description</th>
                      <th style={{ width: '120px', textAlign: 'center' }}>Variant</th>
                      <th style={{ width: '60px', textAlign: 'center' }}>Qty</th>
                      <th style={{ width: '110px', textAlign: 'right' }}>Unit Price</th>
                      <th style={{ width: '120px', textAlign: 'right' }}>Total Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {order.orderItems && order.orderItems.map((item, idx) => (
                      <tr key={idx}>
                        <td style={{ textAlign: 'center' }}>{idx + 1}</td>
                        <td>
                          <strong>{item.name}</strong>
                          <div style={{ fontSize: '11px', color: '#666' }}>Sold by: {sellerName}</div>
                        </td>
                        <td style={{ textAlign: 'center' }}>
                          {[item.size ? `Size ${item.size}` : '', item.colour || ''].filter(Boolean).join(' | ') || '-'}
                        </td>
                        <td style={{ textAlign: 'center' }}>{item.quantity}</td>
                        <td style={{ textAlign: 'right' }}>₹{(item.price || 0).toLocaleString('en-IN')}</td>
                        <td style={{ textAlign: 'right', fontWeight: 'bold' }}>
                          ₹{((item.price || 0) * (item.quantity || 1)).toLocaleString('en-IN')}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Totals Section */}
              <div className="inv-totals-wrap">
                <table className="inv-totals-table">
                  <tbody>
                    <tr>
                      <td>Items Subtotal:</td>
                      <td style={{ textAlign: 'right' }}>₹{(order.itemPrice || 0).toLocaleString('en-IN')}</td>
                    </tr>
                    <tr>
                      <td>Shipping & Delivery Charges:</td>
                      <td style={{ textAlign: 'right' }}>{(order.shippingPrice || 0) > 0 ? `₹${(order.shippingPrice).toLocaleString('en-IN')}` : 'FREE'}</td>
                    </tr>
                    {(order.taxPrice || 0) > 0 && (
                      <tr>
                        <td>GST Tax:</td>
                        <td style={{ textAlign: 'right' }}>₹{(order.taxPrice).toLocaleString('en-IN')}</td>
                      </tr>
                    )}
                    {order.coupanInfo && order.coupanInfo.coupanValue > 0 && (
                      <tr>
                        <td>Coupon Discount ({order.coupanInfo.coupanName}):</td>
                        <td style={{ textAlign: 'right', color: '#16a34a' }}>-₹{(order.coupanInfo.coupanValue).toLocaleString('en-IN')}</td>
                      </tr>
                    )}
                    {order.adavncePayment && order.adavncePayment.amount > 0 && (
                      <tr>
                        <td>Advance Paid Online:</td>
                        <td style={{ textAlign: 'right', color: '#0284c7' }}>-₹{(order.adavncePayment.amount).toLocaleString('en-IN')}</td>
                      </tr>
                    )}
                    <tr className="inv-grand-total-row">
                      <td><strong>Total Order Value:</strong></td>
                      <td style={{ textAlign: 'right' }}><strong>₹{(order.totalPrice || 0).toLocaleString('en-IN')}</strong></td>
                    </tr>
                    {dueAmount > 0 && (
                      <tr className="inv-due-row">
                        <td><strong>Balance to Collect on Delivery:</strong></td>
                        <td style={{ textAlign: 'right' }}><strong>₹{dueAmount.toLocaleString('en-IN')}</strong></td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {/* Best Wishes & Warm Note */}
              <div className="inv-best-wishes-banner">
                <div className="wishes-heading">🌸 Best Wishes from {sellerName} & IM Online Shopping!</div>
                <p className="wishes-message">
                  "Thank you for shopping with us! We appreciate your trust in <strong>{sellerName}</strong>. It was a pleasure serving you, and we sincerely hope you love your purchase. For any assistance, returns, or questions, our team is always here for you."
                </p>
              </div>

              {/* Invoice Signatory Footer */}
              <div className="inv-footer-signature">
                <div className="inv-footer-left">
                  <p>• Returns accepted within 7 days of delivery as per return policy.</p>
                  <p>• For support queries, contact information@imonline.shop or +91 7658007326.</p>
                  <p>• Official Marketplace: www.imonline.shop</p>
                </div>
                <div className="inv-footer-right">
                  <div className="official-stamp-circle">
                    <span>IM ONLINE</span>
                    <small>VERIFIED</small>
                    <span>SEAL</span>
                  </div>
                  <span className="signatory-label">Authorized Signatory / System Generated</span>
                </div>
              </div>

            </div>
          </div>

          {/* Full Screen Printable Invoice Modal Preview */}
          {showInvoiceModal && (
            <div className="invoice-preview-modal-backdrop" onClick={() => setShowInvoiceModal(false)}>
              <div className="invoice-preview-modal" onClick={(e) => e.stopPropagation()}>
                <div className="modal-top-actions">
                  <span className="modal-title">Official Tax Invoice & Receipt Preview</span>
                  <div style={{ display: 'flex', gap: '10px' }}>
                    <button className="modal-print-btn" onClick={() => window.print()}>
                      <PrintIcon style={{ fontSize: '18px', marginRight: '6px' }} />
                      Print / Save as PDF
                    </button>
                    <button className="modal-close-btn" onClick={() => setShowInvoiceModal(false)}>
                      <CloseIcon style={{ fontSize: '20px' }} />
                    </button>
                  </div>
                </div>
                <div className="modal-scroll-content">
                  {/* Reuse official invoice rendering inside modal */}
                  <div className="modal-invoice-clone">
                    <div className="invoice-container">
                      <div className="inv-header">
                        <div className="inv-brand-info">
                          <h1 className="inv-company-name">IM ONLINE SHOPPING CO.</h1>
                          <p className="inv-company-sub">Premier Multi-Vendor E-Commerce Marketplace</p>
                          <p className="inv-company-address">Ahmedgarh, Punjab - 148021 | CIN: U52399PB2026PTC099823</p>
                          <p className="inv-company-contact">Web: www.imonline.shop | Email: information@imonline.shop | Support: +91 7658007326</p>
                        </div>
                        <div className="inv-title-box">
                          <div className="inv-title-badge">TAX INVOICE / CASH MEMO</div>
                          <div className="inv-meta-line"><strong>Invoice No:</strong> {invoiceNumber}</div>
                          <div className="inv-meta-line"><strong>Order ID:</strong> #{order._id}</div>
                          <div className="inv-meta-line"><strong>Date:</strong> {orderDateFormatted}</div>
                        </div>
                      </div>

                      <div className="inv-parties-grid">
                        <div className="inv-party-card seller">
                          <div className="party-title">🏪 SOLD & SUPPLIED BY (MERCHANT):</div>
                          <div className="party-name">{sellerName}</div>
                          <div className="party-line">📍 {sellerFullAddress}</div>
                          <div className="party-line">📞 Phone: {sellerContactPhone}</div>
                          <div className="party-line">✉️ Email: {sellerContactEmail}</div>
                          <div className="party-tag">Status: Verified Merchant Partner</div>
                        </div>

                        <div className="inv-party-card customer">
                          <div className="party-title">📦 BILLED & SHIPPED TO (CUSTOMER):</div>
                          <div className="party-name">{order.shippingInfo?.name || 'Customer'}</div>
                          <div className="party-line">📍 {order.shippingInfo?.address}</div>
                          <div className="party-line">
                            {order.shippingInfo?.city}, {(order.shippingInfo?.district ? `${order.shippingInfo.district}, ` : '')}{order.shippingInfo?.state} - {order.shippingInfo?.pincode}
                          </div>
                          <div className="party-line">📞 Phone: +91 {order.shippingInfo?.phoneNo}</div>
                          {order.shippingInfo?.email && <div className="party-line">✉️ Email: {order.shippingInfo.email}</div>}
                        </div>
                      </div>

                      <div className="inv-payment-bar">
                        <div><strong>Payment Mode:</strong> {isCOD ? 'Cash on Delivery (COD)' : isAdvanceCOD ? 'Advance Paid (Balance on Delivery)' : 'Full Online Payment (Cashfree)'}</div>
                        <div><strong>Payment Status:</strong> {isOnlinePaid ? 'PAID IN FULL' : `DUE ON DELIVERY: ₹${dueAmount.toLocaleString('en-IN')}`}</div>
                        <div><strong>Fulfillment:</strong> {order.orderType || 'HOME_DELIVERY'}</div>
                      </div>

                      <div className="inv-table-responsive">
                        <table className="inv-table">
                          <thead>
                            <tr>
                              <th style={{ width: '40px', textAlign: 'center' }}>#</th>
                              <th style={{ textAlign: 'left' }}>Item Description</th>
                              <th style={{ width: '120px', textAlign: 'center' }}>Variant</th>
                              <th style={{ width: '60px', textAlign: 'center' }}>Qty</th>
                              <th style={{ width: '110px', textAlign: 'right' }}>Unit Price</th>
                              <th style={{ width: '120px', textAlign: 'right' }}>Total Amount</th>
                            </tr>
                          </thead>
                          <tbody>
                            {order.orderItems && order.orderItems.map((item, idx) => (
                              <tr key={idx}>
                                <td style={{ textAlign: 'center' }}>{idx + 1}</td>
                                <td>
                                  <strong>{item.name}</strong>
                                  <div style={{ fontSize: '11px', color: '#666' }}>Sold by: {sellerName}</div>
                                </td>
                                <td style={{ textAlign: 'center' }}>
                                  {[item.size ? `Size ${item.size}` : '', item.colour || ''].filter(Boolean).join(' | ') || '-'}
                                </td>
                                <td style={{ textAlign: 'center' }}>{item.quantity}</td>
                                <td style={{ textAlign: 'right' }}>₹{(item.price || 0).toLocaleString('en-IN')}</td>
                                <td style={{ textAlign: 'right', fontWeight: 'bold' }}>
                                  ₹{((item.price || 0) * (item.quantity || 1)).toLocaleString('en-IN')}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>

                      <div className="inv-totals-wrap">
                        <table className="inv-totals-table">
                          <tbody>
                            <tr>
                              <td>Items Subtotal:</td>
                              <td style={{ textAlign: 'right' }}>₹{(order.itemPrice || 0).toLocaleString('en-IN')}</td>
                            </tr>
                            <tr>
                              <td>Shipping & Delivery Charges:</td>
                              <td style={{ textAlign: 'right' }}>{(order.shippingPrice || 0) > 0 ? `₹${(order.shippingPrice).toLocaleString('en-IN')}` : 'FREE'}</td>
                            </tr>
                            {(order.taxPrice || 0) > 0 && (
                              <tr>
                                <td>GST Tax:</td>
                                <td style={{ textAlign: 'right' }}>₹{(order.taxPrice).toLocaleString('en-IN')}</td>
                              </tr>
                            )}
                            {order.coupanInfo && order.coupanInfo.coupanValue > 0 && (
                              <tr>
                                <td>Coupon Discount ({order.coupanInfo.coupanName}):</td>
                                <td style={{ textAlign: 'right', color: '#16a34a' }}>-₹{(order.coupanInfo.coupanValue).toLocaleString('en-IN')}</td>
                              </tr>
                            )}
                            {order.adavncePayment && order.adavncePayment.amount > 0 && (
                              <tr>
                                <td>Advance Paid Online:</td>
                                <td style={{ textAlign: 'right', color: '#0284c7' }}>-₹{(order.adavncePayment.amount).toLocaleString('en-IN')}</td>
                              </tr>
                            )}
                            <tr className="inv-grand-total-row">
                              <td><strong>Total Order Value:</strong></td>
                              <td style={{ textAlign: 'right' }}><strong>₹{(order.totalPrice || 0).toLocaleString('en-IN')}</strong></td>
                            </tr>
                            {dueAmount > 0 && (
                              <tr className="inv-due-row">
                                <td><strong>Balance to Collect on Delivery:</strong></td>
                                <td style={{ textAlign: 'right' }}><strong>₹{dueAmount.toLocaleString('en-IN')}</strong></td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>

                      <div className="inv-best-wishes-banner">
                        <div className="wishes-heading">🌸 Best Wishes from {sellerName} & IM Online Shopping!</div>
                        <p className="wishes-message">
                          "Thank you for shopping with us! We appreciate your trust in <strong>{sellerName}</strong>. It was a pleasure serving you, and we sincerely hope you love your purchase. For any assistance, returns, or questions, our team is always here for you."
                        </p>
                      </div>

                      <div className="inv-footer-signature">
                        <div className="inv-footer-left">
                          <p>• Returns accepted within 7 days of delivery as per return policy.</p>
                          <p>• For support queries, contact information@imonline.shop or +91 7658007326.</p>
                          <p>• Official Marketplace: www.imonline.shop</p>
                        </div>
                        <div className="inv-footer-right">
                          <div className="official-stamp-circle">
                            <span>IM ONLINE</span>
                            <small>VERIFIED</small>
                            <span>SEAL</span>
                          </div>
                          <span className="signatory-label">Authorized Signatory / System Generated</span>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

        </div>
      )}

      <Footer />
    </Fragment>
  );
}

export default DeliveryProductDetail;